import Vue from 'vue';

export default {
  state: {
    teamApprovalCheckboxes: {},
    teamApprovalRules: {},
    teamMergeRequestApprovedBy: {}
  },
  mutations: {
    setTeamApprovalCheckboxes(state, payload) {
      state.teamApprovalCheckboxes = { ...payload };
    },
    setTeamApprovalRules(state, payload) {
      state.teamApprovalRules = { ...payload };
    },
    addTeamApprovalRule(state, payload) {
      state.teamApprovalRules.items.push(payload);
    },
    editTeamApprovalRule(state, payload) {
      // eslint-disable-next-line array-callback-return, consistent-return
      state.teamApprovalRules.items.find((item, key) => {
        if (item.id === payload.id) {
          Vue.set(state.teamApprovalRules.items, key, payload);
          return true;
        }
      });
    },
    deleteTeamApprovalRule(state, payload) {
      Vue.set(
        state.teamApprovalRules,
        'items',
        state.teamApprovalRules.items.filter((item) => item.id !== payload.id)
      );
    },
    setTeamMergeRequestApprovedBy(state, payload) {
      state.teamMergeRequestApprovedBy = { ...payload };
    }
  },
  actions: {
    setTeamApprovalCheckboxes(state, payload) {
      state.commit('setTeamApprovalCheckboxes', payload);
    },
    setTeamApprovalRules(state, payload) {
      state.commit('setTeamApprovalRules', payload);
    },
    addTeamApprovalRule(state, payload) {
      state.commit('addTeamApprovalRule', payload);
    },
    editTeamApprovalRule(state, payload) {
      state.commit('editTeamApprovalRule', payload);
    },
    deleteTeamApprovalRule(state, payload) {
      state.commit('deleteTeamApprovalRule', payload);
    },
    setTeamMergeRequestApprovedBy(state, payload) {
      state.commit('setTeamMergeRequestApprovedBy', payload);
    }
  },
  getters: {
    setTeamApprovalCheckboxes(state) {
      return state.teamApprovalCheckboxes;
    },
    getTeamApprovalRules(state) {
      return state.teamApprovalRules;
    },
    getTeamMergeRequestApprovedBy(state) {
      return state.teamMergeRequestApprovedBy;
    }
  }
};
